module.exports = __webpack_public_path__ + "static/img/qrcode.a6a03f30.png";